<template>
  <div id="app">
    <nav class="navbar navbar-expand navbar-light bg-white static-top osahan-nav sticky-top">
      &nbsp;&nbsp;
      <button
        class="btn btn-link btn-sm text-secondary order-1 order-sm-0"
        id="sidebarToggle"
      >
        <i class="fas fa-bars"></i>
      </button>
      &nbsp;&nbsp;
      <router-link to="/" class="navbar-brand mr-1">
        <!-- <img class="img-fluid" alt src="./img/logo.png" /> -->
        <img class="img-fluid" alt src="./assets/nlogo.png" style="width:112px; height:29px" />
      </router-link>
      <!-- Navbar Search -->
      <form
        class="d-none d-md-inline-block form-inline ml-auto mr-0 mr-md-5 my-2 my-md-0 osahan-navbar-search"
        style="padding: 8px;"
      >
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Search for..."
            v-model="searh_keywords"
            ref="seach_b"
          />
          <!-- @keydown.enter="press_search(e)" -->
          <div class="input-group-append">
            <button class="btn btn-light" type="button" @click="search_v">
              <i class="fas fa-search"></i>
            </button>
          </div>
        </div>
      </form>
    </nav>
    <div id="wrapper">
      <!-- Sidebar -->
      <ul class="sidebar navbar-nav">
        <li class="nav-item active">
          <router-link to="/" class="nav-link">
            <i class="fas fa-fw fa-home"></i>
            <span>Home</span>
          </router-link>
        </li>
        <li class="nav-item dropdown">
          <router-link
            to="/categories"
            class="nav-link dropdown-toggle"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fas fa-fw fa-list-alt"></i>
            <span>Categories</span>
          </router-link>

          <div class="dropdown-menu">
            <router-link class="dropdown-item" to="/category/action">Action</router-link>
            <router-link class="dropdown-item" to="/category/comedy">Comedy</router-link>
            <router-link class="dropdown-item" to="/category/animation">Animation</router-link>
            <router-link class="dropdown-item" to="/category/drama">Drama</router-link>
            <router-link class="dropdown-item" to="/category/fantasy">Fantasy</router-link>
            <router-link class="dropdown-item" to="/category/romance">Romance</router-link>
            <router-link class="dropdown-item" to="/category/horror">Horror</router-link>
            <router-link class="dropdown-item" to="/category/scifi">Sci-fi</router-link>
            <router-link class="dropdown-item" to="/category/others">Others</router-link>
          </div>
        </li>
      </ul>
      <!-- <router-view></router-view> -->
      <router-view :key="$route.fullPath"></router-view>
    </div>
    <div class="push"></div>
    <footer class="sticky-footer" id="blf">
      <div class="container">
        <div class="row no-gutters">
          <div class="col-lg-12 col-sm-12">
            <p class="mt-1 mb-0">
              <!-- <strong class="text-dark">Vidoe</strong>. -->
              <small class="mt-0 mb-0">
                <a
                  class="text-primary"
                  target="_blank"
                  href="https://www.templatespoint.net/"
                >&copy;2019 Noovo, Inc.</a>
              </small>
            </p>
          </div>
          <!-- <div class="col-lg-6 col-sm-6 text-right">
                     <div class="app">
                        <a href="#"><img alt="" src="../img/google.png"></a>
                        <a href="#"><img alt="" src="../img/apple.png"></a>
                     </div>
          </div>-->
        </div>
      </div>
    </footer>

    <!-- /#wrapper -->
    <!-- Scroll to Top Button-->
    <a class="scroll-to-top rounded" href="#page-top">
      <i class="fas fa-angle-up"></i>
    </a>
    <!-- Logout Modal-->
    <div
      class="modal fade"
      id="logoutModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Ready to Leave?</h5>
            <button class="close" type="button" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div
            class="modal-body"
          >Select "Logout" below if you are ready to end your current session.</div>
          <div class="modal-footer">
            <button class="btn btn-secondary" type="button" data-dismiss="modal">Cancel</button>
            <a class="btn btn-primary" href="login.html">Logout</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import HelloWorld from "./components/HelloWorld.vue";
import BasicAPIs from "./api/apis";
export default {
  name: "app",
  components: {
    // HelloWorld
  },
  mounted() {
    let noovo_played_recently = JSON.parse(
      window.localStorage.getItem("noovo_played_recently")
    );

    console.log("noovo_played_recently: " + typeof noovo_played_recently);
    if (noovo_played_recently !== null && noovo_played_recently.length > 0) {
      this.$store.commit("initPlayed_recently", noovo_played_recently);
    }

    // document.body.insertBefore(this.$el, document.body.firstChild);
    // window.addEventListener("resize", this.cnmft);
    window.addEventListener("keypress", this.press_search);
  },
  data: function() {
    return {
      a: "hello",
      searh_keywords: ""
    };
  },
  created() {
    let vm = this;

    BasicAPIs.getCategory().then(res => {
      if (res.status === 200) {
        // console.log(res.data);
        // console.log("category updated");
        vm.$store.commit("update_categories", res.data);
      } else {
        alert("api error @app");
      }
    });
  },
  computed: {
    playlist_recent() {
      return this.$store.state.played_recently;
    },
    currentsec() {
      return Date.now().toString();
    }
  },
  beforedestroy() {
    window.removeEventListener("keypress", this.press_search);
  },
  methods: {
    press_search(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        console.log("pressed search " + this.searh_keywords);
        this.search_v();
      }
    },
    search_v() {
      let filtered_kw = this.searh_keywords; // TODO: 检查合法化
      console.log("search " + filtered_kw);

      // this.searh_keywords = "";
      // this.$router.go({ name: "search", params: { keywords: filtered_kw } });
      this.$router.push({ name: "search", params: { keywords: filtered_kw } });
    },

    cnmft() {
      let page_height = window.innerHeight;
      let footer = document.querySelector("#blf");
      let overalh = this.offset(footer).top + footer.style.height;
      if (overalh) {
        //pass
      }
      //set height
      footer.style.top = page_height - footer.offsetHeight;
      console.log(
        "resize: " +
          this.offset(footer).top +
          " " +
          footer.offsetHeight +
          " ? " +
          page_height
      );
    },
    offset(el) {
      var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    }
  },
  watch: {
    $route(to, from) {
      console.log("route changed");
      this.cnmft();
    }
  }
};
</script>

<style lang="scss">
#app {
  min-height: 100%;

  /* Equal to height of footer */
  /* But also accounting for potential margin-bottom of last child */
  margin-bottom: -50px;
  display: flex;
  flex-direction: column;
}
footer,
.push {
  height: 50px;
}
#wrapper {
  flex-grow: 1;
}
</style>
